// Geometry helpers for the custom-vineyard draw tool.
// Points are [lat, lng] pairs in draw order; a "chunk" is one closed ring.

// Proper segment intersection (excludes shared endpoints).
function segmentsCross(a, b, c, d) {
  const cross = (o, p, q) => (p[0] - o[0]) * (q[1] - o[1]) - (p[1] - o[1]) * (q[0] - o[0]);
  const d1 = cross(c, d, a);
  const d2 = cross(c, d, b);
  const d3 = cross(a, b, c);
  const d4 = cross(a, b, d);
  return ((d1 > 0 && d2 < 0) || (d1 < 0 && d2 > 0)) &&
         ((d3 > 0 && d4 < 0) || (d3 < 0 && d4 > 0));
}

// True when the ring (auto-closed) self-intersects. O(n²) — fine for
// hand-drawn shapes with tens of points.
export function ringSelfIntersects(points) {
  const n = points.length;
  if (n < 4) return false;
  const seg = (i) => [points[i], points[(i + 1) % n]];
  for (let i = 0; i < n; i++) {
    for (let j = i + 1; j < n; j++) {
      // skip adjacent segments (they share a vertex, incl. the wrap pair)
      if (j === i + 1 || (i === 0 && j === n - 1)) continue;
      const [a, b] = seg(i);
      const [c, d] = seg(j);
      if (segmentsCross(a, b, c, d)) return true;
    }
  }
  return false;
}

// Validate a ring about to close. Returns null when fine, else a message.
export function validateRing(points) {
  if (points.length < 3) return 'A shape needs at least 3 points.';
  if (ringSelfIntersects(points)) return 'This shape crosses itself — undo the last point(s) and try again.';
  return null;
}

// chunks: [{ points: [[lat,lng],...] }] → GeoJSON MultiPolygon (lng/lat order,
// rings explicitly closed).
export function chunksToGeoJSON(chunks) {
  return {
    type: 'MultiPolygon',
    coordinates: chunks.map(({ points }) => {
      const ring = points.map(([lat, lng]) => [lng, lat]);
      ring.push(ring[0]);
      return [ring];
    }),
  };
}
